import React, { useEffect, useState } from "react";

import Review from "../Review/Review";
import "./Reviews.css";

const Reviews = () => {
  const [reviews, setReviews] = useState([]);
  useEffect(() => {
    fetch(`data.json`)
      .then((res) => res.json())
      .then((data) => setReviews(data));
  }, []);
  return (
    <section>
      <div>
        <h1>What our customers say</h1>
      </div>
      <div className="reviews-container">
        {
        reviews.map(review =><Review 
          key={review.id} 
          review={review}
          ></Review>
        )}
      </div>
    </section>
  );
};

export default Reviews;
